<template>
  <div>
  <v-container
    v-if="isChapterSalesOnly && !chapterSalesAccessChecked"
    fluid
    class="py-12"
  >
    <v-progress-linear color="primary" indeterminate rounded height="6" />
  </v-container>
  <v-alert
    v-else-if="isChapterSalesOnly && !chapterSalesAffiliationAllowed"
    type="error"
    class="ma-6"
  >
    No tienes acceso a las ventas de esta membresía.
  </v-alert>
  <v-container v-else fluid>
    <v-card color="px-0 py-7 rounded-xl elevation-0">
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tab">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab href="#sales">Ventas</v-tab>
            <v-tab v-if="!isChapterSalesOnly" href="#membershipLevels">Tipos de membresía</v-tab>
            <v-tab v-if="!isChapterSalesOnly" href="#coupons">Cupones</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="sales">
              <sales
                :affiliationId="affiliationId"
                :chapter-sales="chapterSalesAffiliationAllowed"
              />
            </v-tab-item>
            <v-tab-item v-if="!isChapterSalesOnly" value="membershipLevels">
              <access :affiliationId="affiliationId" />
            </v-tab-item>
            <v-tab-item v-if="!isChapterSalesOnly" value="coupons">
              <coupons :affiliationId="affiliationId" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Access, Coupons, Sales } from './tabs/index';

export default {
  components: {
    Access,
    Coupons,
    Sales
  },
  props: ['affiliationId'],
  computed: {
    ...mapState('user', ['user']),
    isChapterSalesOnly() {
      return this.user?.role === 'BRANCH';
    },
  },
  data: () => ({
    tab: 'sales',
    chapterSalesAccessChecked: false,
    chapterSalesAffiliationAllowed: false,
  }),
  async created() {
    if (!this.isChapterSalesOnly) {
      this.chapterSalesAccessChecked = true;
      return;
    }

    try {
      const { data } = await this.axios.get('/affiliations/chapter-sales');
      this.chapterSalesAffiliationAllowed = (data?.affiliations || []).some(
        (affiliation) =>
          String(affiliation._id || affiliation.id) === String(this.affiliationId)
      );
    } catch (error) {
      this.chapterSalesAffiliationAllowed = false;
    } finally {
      this.chapterSalesAccessChecked = true;
    }
  },
};
</script>
